import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Dashboard.module.css';

const MunicipalityTechnicalDashboard = ({ onNavigateToMap }) => {
  const { user, userRole, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: '' },
    { id: 'maintenance', label: 'Bakım İşlemleri', icon: '' },
    { id: 'monitoring', label: 'İzleme', icon: '' },
    { id: 'reports', label: 'Teknik Raporlar', icon: '' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <div>
          <h1>Teknik Ekip Dashboard</h1>
          <p>Hoş geldiniz, {user?.email || user?.username}</p>
          <p className={styles.roleBadge}>Rol: {userRole}</p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button 
            onClick={logout}
            className={styles.logoutButton}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      <div className={styles.dashboardTabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className={styles.tabIcon}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.dashboardContent}>
        {activeTab === 'overview' && (
          <div className={styles.overviewContainer}>
            <div className={styles.overviewHeader}>
              <h2>Genel Bakış</h2>
              <button 
                onClick={onNavigateToMap}
                className={styles.mapButton}
              >
                <span className={styles.mapButtonIcon}></span>
                Harita Üzerinden İnceleme Yap
              </button>
            </div>
            <div className={styles.overviewCards}>
              <div className={styles.overviewCard}>
                <h3>Aktif Bakım Görevleri</h3>
                <p className={styles.cardValue}>7</p>
                <p className={styles.cardLabel}>Bekleyen</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Sistem Durumu</h3>
                <p className={styles.cardValue}>Normal</p>
                <p className={styles.cardLabel}>Tüm sistemler çalışıyor</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Bu Ay Tamamlanan</h3>
                <p className={styles.cardValue}>23</p>
                <p className={styles.cardLabel}>Bakım işlemi</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'maintenance' && (
          <div className={styles.maintenanceContainer}>
            <div className={styles.maintenanceHeader}>
              <h2>Bakım İşlemleri</h2>
              <button className={styles.addButton}>+ Yeni Bakım Görevi</button>
            </div>
            
            <div className={styles.maintenanceList}>
              <div className={styles.maintenanceItem}>
                <div className={styles.maintenanceInfo}>
                  <h3>Pompa İstasyonu #3 - Periyodik Bakım</h3>
                  <p>Konum: Merkez Bölge | Tarih: 15.04.2024</p>
                  <span className={styles.statusBadge}>Beklemede</span>
                </div>
                <div className={styles.maintenanceActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Başlat</button>
                </div>
              </div>
              
              <div className={styles.maintenanceItem}>
                <div className={styles.maintenanceInfo}>
                  <h3>Su Deposu #1 - Temizlik</h3>
                  <p>Konum: Kuzey Bölge | Tarih: 18.04.2024</p>
                  <span className={styles.statusBadge}>Planlandı</span>
                </div>
                <div className={styles.maintenanceActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Başlat</button>
                </div>
              </div>
              
              <div className={styles.maintenanceItem}>
                <div className={styles.maintenanceInfo}>
                  <h3>Filtre Sistemi #2 - Değişim</h3>
                  <p>Konum: Güney Bölge | Tarih: 20.04.2024</p>
                  <span className={styles.statusBadge}>Devam Ediyor</span>
                </div>
                <div className={styles.maintenanceActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Güncelle</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'monitoring' && (
          <div className={styles.monitoringContainer}>
            <div className={styles.monitoringHeader}>
              <h2>Sistem İzleme</h2>
              <p className={styles.monitoringSubtitle}>Gerçek zamanlı sistem durumu ve metrikler</p>
            </div>
            
            <div className={styles.monitoringGrid}>
              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <span className={styles.metricIcon}></span>
                  <h3>Su Basıncı</h3>
                </div>
                <div className={styles.metricValue}>4.2 bar</div>
                <div className={styles.metricLabel}>Normal aralıkta</div>
                <div className={styles.metricBar}>
                  <div className={styles.metricBarFill} style={{ width: '70%', background: '#22c55e' }}></div>
                </div>
              </div>
              
              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <span className={styles.metricIcon}></span>
                  <h3>Sıcaklık</h3>
                </div>
                <div className={styles.metricValue}>18°C</div>
                <div className={styles.metricLabel}>Optimal seviye</div>
                <div className={styles.metricBar}>
                  <div className={styles.metricBarFill} style={{ width: '60%', background: '#3b82f6' }}></div>
                </div>
              </div>
              
              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <span className={styles.metricIcon}></span>
                  <h3>Enerji Tüketimi</h3>
                </div>
                <div className={styles.metricValue}>245 kW</div>
                <div className={styles.metricLabel}>Bu saat</div>
                <div className={styles.metricTrend}>↗ +5%</div>
              </div>
              
              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <span className={styles.metricIcon}></span>
                  <h3>Aktif Ekipman</h3>
                </div>
                <div className={styles.metricValue}>18/20</div>
                <div className={styles.metricLabel}>Çalışıyor</div>
                <div className={styles.metricBar}>
                  <div className={styles.metricBarFill} style={{ width: '90%', background: '#22c55e' }}></div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'reports' && (
          <div className={styles.reportsContainer}>
            <div className={styles.reportsHeader}>
              <h2>Teknik Raporlar</h2>
              <button className={styles.addButton}>+ Yeni Rapor Oluştur</button>
            </div>
            
            <div className={styles.reportsList}>
              <div className={styles.reportItem}>
                <div className={styles.reportInfo}>
                  <h3>Aylık Bakım Raporu - Mart 2024</h3>
                  <p>Oluşturulma: 01.04.2024 | Durum: Tamamlandı</p>
                </div>
                <div className={styles.reportActions}>
                  <button className={styles.viewButton}>Görüntüle</button>
                  <button className={styles.downloadButton}>İndir</button>
                </div>
              </div>
              
              <div className={styles.reportItem}>
                <div className={styles.reportInfo}>
                  <h3>Sistem Performans Analizi - Q1 2024</h3>
                  <p>Oluşturulma: 05.04.2024 | Durum: Hazırlanıyor</p>
                </div>
                <div className={styles.reportActions}>
                  <button className={styles.viewButton}>Görüntüle</button>
                  <button className={styles.downloadButton}>İndir</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MunicipalityTechnicalDashboard;

